import React, { useEffect, useState } from "react";
import { Box, Flex } from "@chakra-ui/react";
import "./videopromotion.css";
import { Colors } from "../../../../static/static";
import { getHomeVideos } from "../../../../services/webService";
import  {convertToEmbedUrl}  from "../../../../helpers/youtubeHelper";

function VideoPromotion() {
  const [video, setVideo] = useState({});
  useEffect(() => {
    const fetchHomeVideos = async () => {
      try {
        const videos = await getHomeVideos();
        if (videos.length > 0) {
          setVideo(videos[0]);
        }
      } catch (error) {
        console.error("Error while trying to get video:", error);
      }
    };
    fetchHomeVideos();
  }, []);

  return (
    <Box className="videopromotion-container" bg={Colors.bgBlack}>
      <Flex
        justifyContent="center"
        alignItems="center"
        width="100%"
        height="100%"
      >
        <Box
          width={{ base: "95%", md: "80%" }}
          height={{ base: "95%", md: "75%" }}
        >
          <iframe
            width="100%"
            height="100%"
            src={convertToEmbedUrl(video.url)}
            title={video.title}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
          ></iframe>
        </Box>
      </Flex>
    </Box>
  );
}

export default VideoPromotion;
